import { useSearchInitializer } from "../context";
import { useSubmitHandler } from "./useSubmitHandler";
// Creates a search handler that submits a search with default form state
var useSubmitInitialSearch = function() {
    var handleSearch = useSubmitHandler();
    var getDefaultState = useSearchInitializer().getDefaultState;
    return {
        makeSearchHandler: function(location) {
            if (!location || !location.query) {
                return undefined;
            }
            var searchData = getDefaultState(location || null);
            return function(query) {
                handleSearch(searchData, query);
            };
        }
    };
};
export { useSubmitInitialSearch };
